module.exports = __webpack_public_path__ + "media/packs/compcalc/components/images/ndi-bb647e4f3b5554261a124c1b65644d56.png";